import type { LogEventType } from "./logger-core";

export enum LogTags {
  NONE = "",
  LOGIN_CODE = "Login Code",
  ACCOUNT_ACCESS = "Account Access",
  SUPPORT = "Support",
  MODULE_ACCESS = "Module Access",
  ACCOUNT_DETAILS = "Account Details",
}

export enum LogEventTypeEnum {
  PAGE_VIEW = "PAGE_VIEW",
  USER_INTERACTION = "USER_INTERACTION",
}

export enum LogCategories {
  NONE = "",
  LOGIN_GROUP_ID = "Login Group Id",
  LOGIN = "Login",
  LOCATE_ACCOUNT = "Locate Account",
  MESSAGE_SUPPORT = "Message Support",
  CHATBOT = "Chatbot",
  BIOMETRICS_SETTING = "Biometrics Setting",
  TERMS_AND_CONDITION = "Terms & Condition",
  PRIVACY_POLICY = "Privacy Policy",
  SIGN_UP = "Sign Up",
  PASSWORD_RESET = "Password Reset",
  HOME = "Home",
  PROFILE_UPDATE = "Update Profile",
  CARE_AND_CLAIMS_HISTORY = "Care and Claims History",
  ID_CARD = "ID Card",
  REQUEST_NEW_ID_CARD = "Request New ID Card",

  DATA_ACCESS_MANAGEMENT = "Data Access Management",
  PAPERLESS_EOB = "Paperless Eob",

  MY_BENEFITS = "My Benefit",
  SPEND_SUMMARY = "Spend Summary",
  BALANCE_BILL = "Balance Bill",
  COST_ESTIMATOR = "Cost Estimator",
  HCBB_COST_ESTIMATOR = "Cost Estimator Enhanced",
  NOTIFICATIONS = "Notifications",
  PROVIDER_SEARCH = "Provider Search",
  SERVICES = "Services",
  CSR_CHAT = "CSR Chat",
  VIDEOS = "Videos",

  INVITE_USER_WIDGET = "Invite User Widget",
  RECENT_MEDICAL_WIDGET = "Recent Medical Widget",
}

export enum LogSubCategories {
  NONE = "",
  GROUP_INFO_MODAL = "Group Info",
  OTP_VERIFICATION = "OTP Verification",
  FORGOT_USERNAME = "Forgot Username",
  FORGOT_PASSWORD = "Forgot Password",
  CARE_HISTORY_EOB_CARD = "EOB Card",
  DOWNLOAD_ID_CARD = "Download ID Card",
  REQUEST_NEW_ID_CARD = "Request New ID Card",

  ACCESS_GRANT_DISCLAIMER = "Access Grant Disclaimer",
  ACCESS_REVOKE_DISCLAIMER = "Access Revoke Disclaimer",
  ACCESS_DECLINE_ACKNOWLEDGE = "Access Decline Acknowledge Disclaimer",
  ACCESS_ACCEPT_ACKNOWLEDGE = "Access Accept Acknowledge Disclaimer",
  ACCESS_CONSENT = "Access Consent Disclaimer",

  SWITCH_TO_PAPERLESS_EOB = "Switch to Paperless Eob",
  MANAGE_EOB = "Manage Eob",

  CARE_HISTORY_VISIT_DETAILS = "Visit Details",
  CARE_HISTORY_DOWNLOAD_CLAIMS = "Download Claims",

  PROVIDER_SEARCH_RESULT = "Provider Search Result",

  INVITE_USER = "Invite User",
}

export enum LogActionTypes {
  BTN_SUBMIT = "Submit Button",
  BTN_BUTTON = "Button",
}

export const PANEL = {
  VISIT_DETAILS: "Visit Details Screen",
  REQUEST_NEW_ID_CARD: "request new id card screen",
  CARE_HISTORY_FILTER: "Care History Filter Screen",
  MESSAGE_SUPPORT: "Message Support",
} as const;

export const CustomLogTitle = {
  EOB_CARD: "eob card opened",
} as const;

export type LogPanel = (typeof PANEL)[keyof typeof PANEL];

export type RouteIdentifier = {
  code: string;
  path: string;
  legacyName?: string;
  screenName?: string;
  tag: LogTags;
  category: LogCategories;
  subCategory: LogSubCategories;
};

export type LogContext = {
  tag: LogTags;
  category?: LogCategories;
  subCategory?: LogSubCategories;
  type?: LogEventType;
};
